import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AnalyticsService } from "../../core/analytics.service";
import { Component, OnInit, ViewChild } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ConsultOrderElsewhereCompletionComponent } from "../consult-order-elsewhere-completion/consult-order-elsewhere-completion.component";
import { Observable, Subject } from "rxjs";
import { Task } from "../../shared/task";
import { TaskService } from "../../shared/task.service";
import { WindowService } from "../../core/window.service";

@Component({
  selector: "om-details",
  templateUrl: "./details.component.html",
  styleUrls: ["./details.component.scss"],
})
export class DetailsComponent implements OnInit {
  private _task$ = new Subject();
  task$: Observable<Task> = <Observable<Task>>this._task$.asObservable();
  task: Task;

  declineModalRef: NgbModalRef;
  @ViewChild("declineModal") declineModal;
  @ViewChild("completeModal") completeModal;
  isWebView = false;

  @ViewChild("wentElsewhereModal") wentElsewhereModal;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private taskService: TaskService,
    private analyticsService: AnalyticsService,
    private modalService: NgbModal,
    private windowService: WindowService
  ) {}

  ngOnInit() {
    this.isWebView = this.route.snapshot.queryParams.is_web_view == "true";
    this.route.paramMap.subscribe(params => {
      this.taskService.getTask(params.get("id")).subscribe(task => this._task$.next(task));
    });

    this.task$.subscribe(task => {
      this.task = task;
      this.analyticsService.setModule("Task Page");
      this.analyticsService.patientTaskViewed(task);
    });
  }

  showCompleteModal() {
    this.analyticsService.setModule("Task Page");
    if (this.task.type == "consult_order") {
      this.analyticsService.patientTaskAlreadyDoneTapped(this.task, { specialist: "Referred" });
      this.completeTask({
        analyticData: { specialist: "Referred" },
      });
    } else {
      this.analyticsService.patientTaskAlreadyDoneTapped(this.task);
      this.completeModal.open();
    }
  }

  closeCompleteModal() {
    this.completeModal.close();
  }

  completeTask(data?) {
    this.taskService
      .updateTask(this.task.id, "complete", data.completionData)
      .subscribe(this.reloadTask.bind(this));

    this.windowService.postMessageToWebView({ action: "taskFinished" });
    this.windowService.invokeOnInterface("Android", "taskFinished");

    if (this.task.type == "consult_order") {
      this.setSelfReportModule(data.analyticData);
      this.analyticsService.patientTaskAlreadyDone(this.task, data.analyticData);
    } else {
      this.analyticsService.patientTaskAlreadyDone(this.task);
    }
  }

  setSelfReportModule(property) {
    if (property.specialist == "Elsewhere") {
      this.analyticsService.setModule("Task Self Report Page");
    }
  }

  showDeclineModal() {
    this.declineModalRef = this.modalService.open(this.declineModal);
    this.analyticsService.patientTaskDeclineTapped(this.task);
  }

  secondButtonCompleted() {
    if (this.task.type == "consult_order") {
      this.modalService.open(this.wentElsewhereModal);
      this.analyticsService.patientTaskAlreadyDoneTapped(this.task, {
        specialist: "Elsewhere",
      });
    }
  }

  declineTask() {
    this.taskService.updateTask(this.task.id, "decline").subscribe(this.reloadTask.bind(this));

    this.windowService.postMessageToWebView({ action: "taskFinished" });
    this.windowService.invokeOnInterface("Android", "taskFinished");
    this.analyticsService.setModule("Task Page");
    this.analyticsService.patientTaskDeclined(this.task);
  }

  reloadTask(task) {
    this.task = Task.fromApiV2(task);
    this._task$.next(this.task);
    if (this.declineModalRef) {
      this.declineModalRef.close();
    }
    if (this.completeModal) {
      this.completeModal.close();
    }
  }
}
